import { render, staticRenderFns } from "./XAxisSelectorAntV.vue?vue&type=template&id=38766360&scoped=true&"
import script from "./XAxisSelectorAntV.vue?vue&type=script&lang=js&"
export * from "./XAxisSelectorAntV.vue?vue&type=script&lang=js&"
import style0 from "./XAxisSelectorAntV.vue?vue&type=style&index=0&id=38766360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38766360",
  null
  
)

export default component.exports